



import { defineComponent } from "@vue/composition-api";
import AppStorage from "@/lib/appStorage";
import config from "@/config";
import ConfirmSensitiveContentView from "./components/ConfirmSensitiveContentView.vue";

export default defineComponent({
  name: "ConfirmSensitiveContent",
  components: { ConfirmSensitiveContentView },
  props: {
    askEveryTime: { type: Boolean, default: false },
  },
  data() {
    return {
      storageShowSensitiveContent: config.disableAdult
        ? 1
        : this.askEveryTime && AppStorage.getNumber("showSensitiveContent", -1) !== 1
        ? -1
        : AppStorage.getNumber("showSensitiveContent", -1),
    };
  },
  computed: {
    hideConfirm(): boolean {
      return this.storageShowSensitiveContent > -1;
    },
  },
  methods: {
    confirm(sensitive: number) {
      this.storageShowSensitiveContent = sensitive;
      AppStorage.setNumber("showSensitiveContent", sensitive);
      this.$emit("confirm", !!sensitive);
    },
  },
  created() {
    if (this.hideConfirm) {
      this.confirm(this.storageShowSensitiveContent);
    }
  },
});
